import { isMcpAuthorizationPageError, MCP_AUTHORIZATION_ERROR_MESSAGES } from '@easyhelp/shared';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { useSearchParams } from 'react-router';
import { McpAuthorizationLayout } from './McpAuthorizationLayout';

const UNKNOWN_ERROR = 'Il collegamento non è riuscito. Torna al client e riprova.';

/**
 * Pagina d'errore dell'autorizzazione MCP (`/autorizzazione-mcp/errore?codice=`): l'API ci manda
 * il browser quando non può tornare al client, perché il client è sconosciuto o il suo redirect non
 * è ammesso (ADR-005). Non serve la sessione.
 */
export function McpAuthorizationErrorPage() {
  const [params] = useSearchParams();
  const code = params.get('codice');
  return (
    <McpAuthorizationLayout title="Collegamento non riuscito">
      <Alert severity="error">
        {isMcpAuthorizationPageError(code) ? MCP_AUTHORIZATION_ERROR_MESSAGES[code] : UNKNOWN_ERROR}
      </Alert>
      <Typography>
        Se il problema resta, avvisa l'amministratore indicando il client (Claude, Claude Code o Cursor) e l'ora.
      </Typography>
    </McpAuthorizationLayout>
  );
}
